<template>
  <BlBackdrop
    title="Adjust team size limit"
    label="Update"
    :disabled="isDisabledSubmit"
    :submitLoading="submitLoading"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onUpdate"
  >
    <div
      class="flex flex-col gap-5 px-8"
      :style="{ width: '40rem', maxHeight: 'calc(100vh - 14rem)' }"
    >
      <div
        class="flex flex-col items-center justify-center gap-1 bg-slate-200 rounded-tl-none rounded py-3"
      >
        <div class="flex items-center gap-4">
          <button
            type="button"
            class="outline-none flex h-6 w-6 items-center justify-center rounded-full border border-slate-600 transition-all duration-300"
            :class="[
              teamSizeLimitInput <= 1
                ? 'text-slate-600 bg-slate-400 pointer-events-none'
                : 'text-dark-purple-100 bg-pure-white hover:bg-light-purple-100'
            ]"
            @click="teamSizeLimitInput = Number(teamSizeLimitInput) - 1"
          >
            <BlIcon icon="minus" class="h-4 w-4" />
          </button>
          <input
            type="number"
            name="credit_count"
            id="credit_count"
            v-model="teamSizeLimitInput"
            class="outline-none flex w-50 h-18 items-center justify-center rounded border border-slate-500 text-center text-6xl font-bold focus:border-light-purple"
            :class="[
              teamSizeLimitInput <= 0
                ? 'text-error-300'
                : 'text-dark-purple-100'
            ]"
          />
          <button
            type="button"
            class="outline-none flex h-6 w-6 items-center justify-center rounded-full border border-slate-600 text-dark-purple-100 bg-pure-white hover:bg-light-purple-100 transition-all duration-300"
            @click="teamSizeLimitInput = Number(teamSizeLimitInput) + 1"
          >
            <BlIcon icon="plus" class="h-4 w-4" />
          </button>
        </div>
        <div class="flex flex-col items-center">
          <BlTextBody3 text="seats(s)" />
          <BlTextBody3
            v-if="teamSizeLimitInput < 0"
            text="Please input seats(s) starts from 1"
            class="text-error-300"
          />
        </div>
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlBackdrop from "../../../BlBackdrop.vue";
import BlTextBody3 from "../../../BlTextBody3.vue";
import BlIcon from "../../../BlIcon.vue";

export default {
  name: "EditTeamSizeLimitModal",
  components: {
    BlBackdrop,
    BlTextBody3,
    BlIcon
  },
  props: {},
  data() {
    return {
      submitLoading: false,
      teamSizeLimitInput: 0
    };
  },
  computed: {
    ...mapGetters(["currentUser", "center"]),
    isDisabledSubmit() {
      return false;
    }
  },
  watch: {},
  mounted() {
    this.teamSizeLimitInput = this.center.team_size_limit || 0;
  },
  methods: {
    ...mapActions(["updateCenter"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    async onUpdate() {
      const params = {
        id: this.center.id,
        center: {
          team_size_limit: this.teamSizeLimitInput
        },
        title: `Seat limit updated`,
        message: `Success! The seat limit has been updated.`
      };

      this.submitLoading = true;
      const { success } = await this.updateCenter(params);
      this.submitLoading = false;
      if (!success) return;
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/superAdmin/center/centerInformation/EditTeamSizeLimitModal.vue